var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPhotoSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddPhotoGroupChat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-4",
    transform: "translate(-213.000000, -364.000000)",
    fill: "#74CD2D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(206.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2353571,12.7142857 L16.2857143,12.7142857 L16.2857143,8.76464286 C16.2857143,7.79428571 15.4707143,7 14.5,7 C13.5292857,7 12.7142857,7.79428571 12.7142857,8.76464286 L12.7142857,12.7142857 L8.76464286,12.7142857 C7.79428571,12.7142857 7,13.5292857 7,14.5 C7,15.4707143 7.79428571,16.2857143 8.76464286,16.2857143 L12.7142857,16.2857143 L12.7142857,20.2353571 C12.7142857,21.2057143 13.5292857,22 14.5,22 C15.4707143,22 16.2857143,21.2057143 16.2857143,20.2353571 L16.2857143,16.2857143 L20.2353571,16.2857143 C21.2057143,16.2857143 22,15.4707143 22,14.5 C22,13.5292857 21.2057143,12.7142857 20.2353571,12.7142857 Z",
    id: "icAddPhotoGroupChat"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPhotoSetting);
export default __webpack_public_path__ + "static/media/icAddPhotoSetting.cba9d500a69fac8ee9e965ba275691c3.svg";
export { ForwardRef as ReactComponent };